module.exports = __webpack_public_path__ + "static/media/x-white.3fcc51ba.svg";